import React, { Fragment } from "react";
import Select from "react-select";
import FormControl from "@material-ui/core/FormControl";
import ProjectGrid from "components/Project/Home/ProjectGrid";
import AxiosConfig from "axiosConfig";
import ActiveProjectInfo from "components/Project/Home/ActiveProjectHomeInfo/ActiveProjectInfo";
import "containers/Projects/Home/Project.css";
import VerticalSpotlightDetails from "components/Spotlight/VerticalSpotlightDetails";
import * as CONSTANT from "constants/text";
import TextTheme from "../../../components/General/Text/TextTheme";
import { Row, Col } from "reactstrap";
import ProjectCard from "components/Spotlight/ProjectCard";

class ProjectsHome extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      categoryList: [],
      projectsList: [
        {
          name: "",
          slug: "",
          banner: "",
        },
      ],
      selectedCategory: "",
      activeProjectsList: [],
      plannedProjectsList: [],
      invitationsList: [],
      attemptedProjectsList: [],
    };
  }

  componentDidMount() {
    this.fetchListOfProjectCategory(this);
    this.fetchProjectDetails(this);
    this.fetchActiveProjectsList(this);
    this.fetchPlannedProjectsList(this);
    this.fetchInvitationsList(this);
  }

  fetchInvitationsList(obj) {
    AxiosConfig.get("impactprojects/project_invitation/")
      .then(function (response) {
        obj.setInvitationsList(response);
      })
      .catch(function (error) {});
  }

  fetchActiveProjectsList(obj) {
    AxiosConfig.get("/impactprojects/attempted_project_list/")
      .then(function (response) {
        obj.setAttemptedProjectList(response);
      })
      .catch(function (error) {});
  }

  fetchPlannedProjectsList(obj) {
    AxiosConfig.get("impactprojects/planning_project_list_new/")
      .then(function (response) {
        obj.setPlannedProjectsList(response);
      })
      .catch(function (error) {});
  }

  fetchListOfProjectCategory(obj) {
    AxiosConfig.get(`impactprojects/category/`)
      .then(function (response) {
        let projArray = [];
        response.data.map((x) =>
          projArray.push({ value: x.name, label: x.name })
        );
        obj.setCategoryList(projArray);
      })
      .catch(function (error) {});
  }

  fetchProjectDetails(obj) {
    AxiosConfig.get("impactprojects/all_projects/")
      .then(function (response) {
        obj.setProjectDetails(response);
      })
      .catch(function (error) {});
  }

  setCategoryList(response) {
    let categoryList = response;
    const fromIndex = categoryList.map(i => i.value).indexOf("Create Your Own Project");
    let obj = categoryList[fromIndex];
    categoryList.splice(fromIndex,1);
    categoryList.splice(0,0,obj);
    this.setState((prevState) => ({
      categoryList: categoryList,
    }));
  }
  setAttemptedProjectList(res) {
    const attemptedProjects = res.data.attempted_project_list;
    const key = "slug";
    const attemptedProjectsList = [
      ...new Map(attemptedProjects.map((item) => [item[key], item])).values(),
    ];
    this.setState({
      attemptedProjectsList: attemptedProjectsList,
    });
  }
  setPlannedProjectsList(response) {
    let plannedProjectsList = response.data;
    this.setState((prevState) => ({
      plannedProjectsList: plannedProjectsList,
    }));
  }

  setInvitationsList(response) {
    let invitationsList = response.data;
    this.setState((prevState) => ({
      invitationsList: invitationsList,
    }));
  }

  setProjectDetails(response) {
    this.setState((prevState) => ({
      projectsList: response.data,
    }));
  }

  onCategoryChange(selected) {
    if (selected !== null) {
      this.setState({ selectedCategory: selected.value });
    } else {
      this.setState({ selectedCategory: "" });
    }
  }
  selectAttemptedProject(projectSlug, y, z) {
    window.location.assign(`/projects/project-summary/${projectSlug}`);
  }
  render() {
    return (
      <div className="header_main">
        <div className="page_main">
          <VerticalSpotlightDetails isSpotlightPage={false} />
          <div className="page_details_main">
            <div className="page_details_content_main">
              <div className="textHeader">Invitations</div>
              {this.state.invitationsList &&
              this.state.invitationsList.length > 0 ? (
                <ActiveProjectInfo
                  projectList={this.state.invitationsList}
                  listType={"Invitation"}
                />
              ) : (
                <TextTheme
                  message={CONSTANT.NO_INVITES}
                  className="mt-15 mb-15 text_small text_med_grey text-center"
                />
              )}
              {/* <hr className="horizontal_line" /> */}
            </div>
            <div className="mt-15 page_details_content_main">
              <div className="textHeader">{CONSTANT.ACTIVE}</div>
              <div className="completedProjContainer">
                <div className="pad-15">
                  {this.state.attemptedProjectsList &&
                  this.state.attemptedProjectsList.length > 0 ? (
                    <Row>
                      {this.state.attemptedProjectsList.map((elem, index) => {
                        return (
                          <Col>
                            <ProjectCard
                              className="completedproject"
                              imageSrc={elem.badge}
                              key={index}
                              projectSlug={elem.slug}
                              onClick={this.selectAttemptedProject.bind(this)}
                            />
                            <span className="text_semi_bold">{elem.name}</span>
                          </Col>
                        );
                      })}
                    </Row>
                  ) : (
                    <TextTheme
                      message={CONSTANT.NO_PROJECTS}
                      className="mt-15 mb-15 text_small text_med_grey text-center"
                    />
                  )}
                </div>
              </div>
              {/* <hr className="horizontal_line" /> */}
            </div>
            <div className="mt-15 page_details_content_main start-project">
              <div className="textHeader">{CONSTANT.START_PROJECT}</div>
              {this.state.projectsList[0] ? (
                this.state.projectsList[0].banner ? (
                  <Fragment>
                    <div className="marginSpaceTop marginSpaceBottom mb-15">
                      <FormControl
                        variant="outlined"
                        style={{
                          marginLeft: "15%",
                          width: "70%",
                        }}
                      >
                        <Select
                          style={{ height: "50px" }}
                          onChange={this.onCategoryChange.bind(this)}
                          options={this.state.categoryList}
                          isClearable
                        />
                      </FormControl>
                    </div>
                    <ProjectGrid
                      projectData={this.state.projectsList}
                      selected={this.state.selectedCategory}
                    />
                  </Fragment>
                ) : null
              ) : (
                <TextTheme
                  message="Currently no projects. Please check back later."
                  className="mt-15 mb-15 text_small text_med_grey text-center"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProjectsHome;
